<script>
import { MoonIcon } from 'vue-feather-icons'
import { ref } from '@vue/composition-api'
import { isEnabled, applyDarkMode } from '@/util/dark-mode'

export default {
  components: {
    MoonIcon,
  },

  setup () {
    const enabled = ref(isEnabled)

    function toggle () {
      applyDarkMode(!enabled.value)
      enabled.value = !enabled.value
    }

    return {
      enabled,
      toggle,
    }
  },
}
</script>

<template>
  <div
    class="button-like flex items-center border rounded-lg px-5 min-h-72p py-2 mb-8 cursor-pointer
    border-gray-300 hover:border-gray-400 dark:border-gray-700 dark-hover:border-gray-600"
    :class="{
      'border-indigo-300 hover:border-indigo-400 dark:border-indigo-600 dark-hover:border-indigo-500': enabled,
    }"
    tabindex="0"
    role="checkbox"
    :aria-checked="!!enabled"
    @click="toggle()"
    @keydown.enter="toggle()"
  >
    <slot name="icon">
      <MoonIcon class="text-teal-500 mr-5" />
    </slot>

    <div class="flex-1 text-gray-800 dark:text-gray-200 text-lg">
      Dark Mode
    </div>

    <BaseSwitch
      :value="enabled"
      tabindex="-1"
      class="pointer-events-none"
      aria-disabled="true"
    />
  </div>
</template>
